export default "/images/vendor/flag-icons/flags/1x1/nf.svg?7988830715c23c9d75b886cea7920356";